import logoOrange from '../../assets/logo-spassu-orange.svg';

export const LogoFullDark = () => (
  <img src={logoOrange} alt="Spassu" style={{ width: 'auto', height: 120 }} />
);
